import React, { useEffect, useState } from "react";
import { Modal, Tabs } from "antd";
import Queries from "./Queries";
import Shortlisted from "./Shortlisted";
import Opened from "./Opened";
import axios from "axios";
const { TabPane } = Tabs;

export default function Index({
  isModalVisible,
  showModal,
  handleOk,
  handleCancel,
  sessionId,
  dataSource,
  modalData,
}) {
  // const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const data = modalData || {};
  function callback(key) {
    console.log(key);
  }
  return (
    <div>
      <Modal
        title={null}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        centered
        width={"50%"}
        bodyStyle={{ padding: 30, height: "80vh", overflow: "scroll" }}
      >
        <Tabs defaultActiveKey="1" onChange={callback}>
          {data?.enquiries?.length > 0 && (
            <TabPane tab="Sent queries" key="1">
              <Queries data={data?.enquiries} loading={loading} />
            </TabPane>
          )}
          {data?.shortlist_product?.length > 0 && (
            <TabPane tab="Shortlisted" key="2">
              <Shortlisted data={data?.shortlist_product} loading={loading} />
            </TabPane>
          )}
          {data?.open_product_modal?.length > 0 && (
            <TabPane tab="Opened " key="3">
              <Opened data={data?.open_product_modal} loading={loading} />
            </TabPane>
          )}
        </Tabs>
      </Modal>
    </div>
  );
}
